import update from 'immutability-helper';
import { AutoWithdrawalData } from 'src/models';
import { ActionType, defaultAction } from 'src/redux/types';
import { reportFunctionError } from 'src/utilities/sentry';
import { ACTION_TYPES } from './types';

export type FetchAutoWithdrawalState = {
  data: AutoWithdrawalData;
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type SubmitAutoWithdrawalState = {
  loading: boolean;
  isSuccess: boolean;
  error: string;
};

export type AutoWithdrawalState = {
  fetch: FetchAutoWithdrawalState;
  submit: SubmitAutoWithdrawalState;
};

const initialState: AutoWithdrawalState = {
  fetch: {
    data: {
      active: false,
      amount: 0,
      createBy: null,
      created: null,
      endDate: null,
      id: null,
      isActive: false,
      isMaxAmount: false,
      lastUpdateBy: null,
      lastUpdated: null,
      maxAmount: false,
      prodAdminFee: 0,
      recipientEmail: '',
      recordFlag: null,
      scheduleType: '',
      startDate: null,
      withdrawalType: '',
    },
    loading: false,
    isSuccess: false,
    error: '',
  },
  submit: {
    loading: false,
    isSuccess: false,
    error: '',
  },
};

export default (state = initialState, action: ActionType = defaultAction) => {
  const { payload, type } = action;
  switch (type) {
    case ACTION_TYPES.AUTO_WITHDRAWAL_FETCH:
      return update(state, {
        fetch: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.AUTO_WITHDRAWAL_FETCH_SUCCESS:
      return update(state, {
        fetch: {
          $merge: {
            data: payload.data,
            loading: false,
            isSuccess: true,
          },
        },
      });

    case ACTION_TYPES.AUTO_WITHDRAWAL_FETCH_FAILED:
      return update(state, {
        fetch: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });

    case ACTION_TYPES.AUTO_WITHDRAWAL_SUBMIT:
      return update(state, {
        submit: {
          loading: {
            $set: true,
          },
        },
      });

    case ACTION_TYPES.AUTO_WITHDRAWAL_SUBMIT_SUCCESS:
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: !payload.reason && payload.status_code === 200,
          },
        },
      });

    case ACTION_TYPES.AUTO_WITHDRAWAL_SUBMIT_FAILED:
      reportFunctionError({
        domain: 'dashboard',
        message: 'Failed to submit auto withdrawal config',
        name: 'postAutoWithdrawalConfig',
        exception: payload,
      });
      return update(state, {
        submit: {
          $merge: {
            loading: false,
            isSuccess: false,
          },
        },
      });
    default:
      return state;
  }
};
